<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <div class="tab-content" style="padding-top: 0 !important;">
      
      <!-- Loading Spinner -->
      @if (loadingData) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      
      @if (!loadingData) {
<form name="screenFrom" id="screenFrom" class="form-horizontal" novalidate>
        
        <!-- Custom Entity Information Table (Original Structure) -->
        <div style="padding-bottom: 0 !important;">
          <table style="width: 100%; border: 0px; border-spacing: 0;" class="custom-table">
            <tbody>
              <tr>
                <td class="LayerLine1" nowrap>Entity:</td>
                <td class="LayerData1" nowrap>
                  {{entityInfo?.leid}} : {{entityInfo?.leName}} : {{entityInfo?.taxYearBegin}} - {{entityInfo?.taxYearEnd}}
                </td>
                <td class="LayerLine1" nowrap>Business:</td>
                <td class="LayerData1" nowrap>
                  {{entityInfo?.meCode}} - {{entityInfo?.meName}}
                </td>
                <td class="LayerLine1" nowrap>Tax Code:</td>
                <td class="LayerData1" nowrap>{{entityInfo?.cdrNo}}</td>
              </tr>
            </tbody>
          </table>
          
          <table class="InnerTblBG custom-table" style="width: 100%; border: 0px; border-spacing: 0; font-weight: bold;">
            <tbody>
              <tr>
                <td class="BlackSmHdrBC">
                  <h4>{{f8824Header?.ATTRIB_DESCRIPTION || 'Form 8824'}}</h4>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Property Table (Occurrence Table) -->
          @if (!loadingData) {
<div id="table_container" class="table-scroll">
            <table class="table table-bordered form-inline InnerTblBG custom-table">
              <thead>
                <tr>
                  <th id="CRD_LINENO_CRUD_1" class="sticky-col">Edit/Delete</th>
                  @for (val of f8824PropertyTable; track $index) {
<th class="sticky-col row">
                    <p>{{val.ATTRIB_DESCRIPTION}}</p>
                  </th>
}
                </tr>
              </thead>
              <tbody>
                <!-- Add New Property Row -->
                <tr>
                  <td>
                    <i class="fa fa-plus-circle color-green fa-2x pull-right"
                       style="cursor: pointer; margin-top: 2px;"
                       title="Add New Property"
                       (click)="AddNewRow(null, null, null)">
                    </i>
                  </td>
                  <td colspan="3">
                    Add New Property
                  </td>
                </tr>

                <!-- Property Data Rows -->
                @if (showOccurrenceTable) {

                @for (row1 of f8824OccDataOriginal; track $index; let mainIndex = $index) {
<tr>
                  <!-- Edit/Delete Column - Not Editing -->
                  @if (row1.IS_EDITTED==='N') {
<td style="width: 4%">
                    <i class="fa fa-pencil bluepencil pull-left"
                       style="cursor: pointer; margin-top: 4px;"
                       title="Edit Details"
                       (click)="editExistingRecord(row1.Line_no, row1.OCCURRENCE, mainIndex, 'edit')">
                    </i>
                    <i class="fa fa-minus-circle color-red fa-2x pull-right"
                       style="cursor: pointer; margin-top: 2px;"
                       title="Remove Details"
                       (click)="removeExistingRecord(row1.Line_no, row1.OCCURRENCE, mainIndex)">
                    </i>
                  </td>
}

                  <!-- Edit/Delete Column - Currently Editing -->
                  @if (row1.IS_EDITTED==='Y') {
<td style="width: 4%">
                    <i class="fa fa-check-circle color-green pull-left"
                       style="cursor: pointer; margin-top: 4px;"
                       title="Save Details"
                       (click)="saveNewEdittedRecord(row1.Line_no, row1.OCCURRENCE, mainIndex)">
                    </i>
                    <i class="fa fa-minus-circle color-red fa-2x pull-right"
                       style="cursor: pointer; margin-top: 2px;"
                       title="Remove Details"
                       (click)="removeExistingRecord(row1.Line_no, row1.OCCURRENCE, mainIndex)">
                    </i>
                  </td>
}

                  <!-- Data Columns - Currently Editing -->
                  @for (item of row1.Row_data; track $index) {
<td style="width: 220px;" 
                      [hidden]="row1.IS_EDITTED!=='Y'">
                    
                    <!-- Label (S No) -->
                    @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='string') {
<div>
                      {{item.ATTRIB_VALUE}}
                      @if (item.HAS_ERROR==='Y') {
<span class="form-error-container">
                        {{item.ATTRIB_VALUE_ERROR}}
                      </span>
}
                    </div>
}
                    
                    <!-- Radio - Schedule -->
                    @if (item.EDIT_TYPE==='radio' && item.DATA_TYPE==='string' && item.ATTRIB_DESCRIPTION==='Schedule') {
<div 
                         style="margin-top: 12px !important;">
                      <label class="radio-inline">
                        <input type="radio" 
                               [name]="'schedule_' + item.OCCURRENCE + '_' + item.LINE_NO" 
                               value="D"
                               [checked]="item.ATTRIB_VALUE === 'D'"
                               (change)="item.ATTRIB_VALUE = 'D'; valuechanged(item, item.OCCURRENCE, item.LINE_NO, item.DATA_TYPE)">
                        Schedule D
                      </label>
                      <label class="radio-inline">
                        <input type="radio" 
                               [name]="'schedule_' + item.OCCURRENCE + '_' + item.LINE_NO" 
                               value="4797"
                               [checked]="item.ATTRIB_VALUE === '4797'"
                               (change)="item.ATTRIB_VALUE = '4797'; valuechanged(item, item.OCCURRENCE, item.LINE_NO, item.DATA_TYPE)">
                        Form 4797
                      </label>
                      @if (item.HAS_ERROR==='Y') {
<span class="form-error-container">
                        {{item.ATTRIB_VALUE_ERROR}}
                      </span>
}
                    </div>
}
                    
                    <!-- Radio - Long/Short Term -->
                    @if (item.EDIT_TYPE==='radio' && item.DATA_TYPE==='string' && item.ATTRIB_DESCRIPTION==='Long / Short Term') {
<div 
                         style="margin-top: 12px !important;">
                      <label class="radio-inline">
                        <input type="radio" 
                               [name]="'longshort_' + item.OCCURRENCE + '_' + item.LINE_NO" 
                               value="Short Term"
                               [checked]="item.ATTRIB_VALUE === 'Short Term'"
                               (change)="item.ATTRIB_VALUE = 'Short Term'; valuechanged(item, item.OCCURRENCE, item.LINE_NO, item.DATA_TYPE)">
                        Short Term
                      </label>
                      <label class="radio-inline">
                        <input type="radio" 
                               [name]="'longshort_' + item.OCCURRENCE + '_' + item.LINE_NO" 
                               value="Long Term"
                               [checked]="item.ATTRIB_VALUE === 'Long Term'"
                               (change)="item.ATTRIB_VALUE = 'Long Term'; valuechanged(item, item.OCCURRENCE, item.LINE_NO, item.DATA_TYPE)">
                        Long Term
                      </label>
                      @if (item.HAS_ERROR==='Y') {
<span class="form-error-container">
                        {{item.ATTRIB_VALUE_ERROR}}
                      </span>
}
                    </div>
}
                  </td>
}

                  <!-- Data Columns - Not Editing (Display Only) -->
                  @for (item of row1.Row_data; track $index) {
<td style="width: 220px;" 
                      [hidden]="row1.IS_EDITTED!=='N'">
                    
                    @if (item.DATA_TYPE == 'number') {
<p [class.color-red]="item.ATTRIB_VALUE < 0">
                      {{item.ATTRIB_VALUE | number}}
                      @if (item.HAS_ERROR==='Y') {
<span class="form-error-container">
                        {{item.ATTRIB_VALUE_ERROR}}
                      </span>
}
                    </p>
}
                    
                    @if (item.DATA_TYPE != 'number' && item.EDIT_TYPE != 'dropdown') {
<p>
                      {{item.ATTRIB_VALUE}}
                      @if (item.HAS_ERROR==='Y') {
<span class="form-error-container">
                        {{item.ATTRIB_VALUE_ERROR}}
                      </span>
}
                    </p>
}
                  </td>
}
                </tr>
}
                
}
              </tbody>
            </table>
          </div>
}

          <!-- Spacer -->
          <div>
            <table>
              <tbody>
                <tr>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Transaction Attributes Table -->
          @if (showTransAttributes) {
<div>
            <table class="table table-bordered form-inline customTable custom-table">
              <thead>
                <tr>
                  <th id="CRD_LINENO_CRUD_1" class="sticky-col">{{tableHeader[0]?.LINE_NO}}</th>
                  <th id="CRD_DESC_CRUD_2" class="sticky-col">{{tableHeader[0]?.DESCRIPTION}}</th>
                  <th id="CRD_HEADER_CRUD_3" class="sticky-col">{{tableHeader[0]?.ATTRIB_DESCRIPTION}}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of getFilteredOuterList(); track $index; let idx = $index) {
<tr class="formDataBlock" 
                   >
                  
                  <!-- Line Number Column -->
                  @if (row.ROW_TYPE != 'PH') {
<td>{{row.LINE_DISP}}</td>
}
                  @if (row.ROW_TYPE == 'PH') {
<td [class.color-red]="row.ROW_TYPE == 'PH'">
                    <b>{{row.LINE_DISP}}</b>
                  </td>
}
                  
                  <!-- Description Column -->
                  @if (row.ROW_TYPE == 'PH') {
<td [class.color-red]="row.ROW_TYPE == 'PH'">
                    <b>{{row.DESCRIPTION}}</b>
                  </td>
}
                  @if (row.ROW_TYPE != 'PH') {
<td>
                    <span>{{row.DESCRIPTION}}</span>
                  </td>
}

                  <!-- Value Column - Non-Radio, Non-PH -->
                  @if (row.EDIT_TYPE != 'radio' && row.ROW_TYPE != 'PH') {
<td align="center" 
                      
                      style="width: 17%;">
                    
                    <!-- Not Editable - Display Only -->
                    @if (row.IS_EDITABLE_CELL == 'N') {
<div style="text-align: right; padding-right: 10px" 
                         
                         [class.color-red]="row.ATTRIB_VALUE < 0">
                      <span id="CRDNOTEDITABLE_{{activeTab}}_CRUD_{{idx + 1}}">
                        {{row.ATTRIB_VALUE | number}}
                      </span>
                    </div>
}
                    
                    <!-- Editable - Number or String Input -->
                    @if (row.IS_EDITABLE_CELL == 'Y' && row.EDIT_TYPE != 'checkbox' && row.EDIT_TYPE != 'custom_date_various' && row.EDIT_TYPE != 'dropdown') {
<div style="text-align: right; padding-right: 10px" 
                        >
                      
                      <!-- Number Input -->
                      @if (row.DATA_TYPE == 'number') {
<div>
                        <input id="CRDNO_{{activeTab}}_CRUD_{{idx + 1}}" 
                               class="form-control input-md numText"
                               style="text-align: right" 
                               type="text"
                               [(ngModel)]="row.ATTRIB_VALUE"
                               [name]="'input_' + idx"
                               placeholder=""
                               onlyIntegersWithLength
                               (blur)="updateAmount(idx, row.OCCURRENCE, row.LINE_NO)" 
                               (ngModelChange)="valuechanged(row, row.OCCURRENCE, row.LINE_NO, row.DATA_TYPE)">
                      </div>
}
                      
                      <!-- String Input -->
                      @if (row.DATA_TYPE == 'string') {
<div>
                        <!-- Text Input -->
                        @if (row.EDIT_TYPE==='text' && row.DATA_TYPE==='string') {
<input id="CRDSTRING_{{activeTab}}_CRUD_{{idx + 1}}" 
                               class="form-control input-md numText"
                              
                               style="text-align: right" 
                               type="text"
                               [(ngModel)]="row.ATTRIB_VALUE"
                               [name]="'input_str_' + idx"
                               placeholder=""
                               (ngModelChange)="valuechanged(row, row.OCCURRENCE, row.LINE_NO, idx)">
}
                        
                        <!-- Textarea -->
                        @if (row.EDIT_TYPE==='textarea' && row.DATA_TYPE==='string') {
<textarea style="width: 100%" 
                                  class="form-control input-sm numText"
                                 
                                  [(ngModel)]="row.ATTRIB_VALUE"
                                  [name]="'textarea_' + idx"
                                  placeholder=""
                                  (ngModelChange)="valuechanged(row, row.OCCURRENCE, row.LINE_NO, row.DATA_TYPE)">
                        </textarea>
}
                      </div>
}
                    </div>
}
                    
                    <!-- Checkbox -->
                    @if (row.EDIT_TYPE == 'checkbox') {
<div>
                      <input id="CRDCHECKBOX_{{activeTab}}_CRUD_{{idx + 1}}" 
                             type="checkbox" 
                             [checked]="row.ATTRIB_VALUE === 'true'"
                             (change)="onCheckboxChange($event, row)">
                    </div>
}
                    
                    <!-- Dropdown -->
                    @if (row.EDIT_TYPE == 'dropdown') {
<div>
                      <select id="CRDDROPDOWN_{{activeTab}}_CRUD_{{idx + 1}}" 
                              style="width: 200px" 
                              class="form-control" 
                              [(ngModel)]="row.ATTRIB_VALUE"
                              [name]="'dropdown_' + idx">
                        <option value="">Select</option>
                        @for (option of formLOV; track $index) {
<option [value]="option.CODE_NAME">
                          {{option.CODE_DESC}}
                        </option>
}
                      </select>
                    </div>
}

                    <!-- Date Picker -->
                    @if (row.EDIT_TYPE == 'custom_date_various') {
<div>
                      <div class="input-group">
                        <input type="date" 
                               class="form-control" 
                               [ngModel]="convertToDateInputFormat(row.ATTRIB_VALUE)"
                               (ngModelChange)="onDateChange($event, row)"
                               [name]="'date_' + idx">
                      </div>
                    </div>
}
                  </td>
}
                  
                  <!-- Radio Button Group Column -->
                  @if (row.EDIT_TYPE == 'radio') {
<td style="padding-left: 30px;">
                    @for (rowData of radioLines; track $index; let radioIdx = $index) {

                      @if (rowData.EDIT_TYPE == 'radio' && rowData.OCCURRENCE === currentOccurrence && row.FORM_LINE_KEY === rowData.FORM_LINE_KEY) {
<div
                           style="display: inline !important; margin-right: 24px;">
                        <input type="checkbox" 
                               [checked]="rowData.ATTRIB_VALUE === 'true'"
                               (change)="onRadioCheckboxChange($event, rowData)">
                        {{rowData.ATTRIB_DESCRIPTION}}
                      </div>
}
                    
}
                  </td>
}
                </tr>
}
              </tbody>
            </table>
          </div>
}
        </div>
      </form>
}
  </div>
</div>

<!-- Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked || !canSave || isLocked"
          (click)="save(currentOccurrence, 'save')">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="reset-button"
          type="button"
          [disabled]="isLocked"
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

